'use strict';

if (!String.prototype.trim) {
  String.prototype.trim = function () {
    return this.replace(/^\s+|\s+$/g, '');
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/rome/src/polyfills/string.trim.js
// module id = 292
// module chunks = 0